import type {
    AssemblyReferenceCollectionFields,
    Content,
} from '@beat-venues/common-types';
import {
    mockContentTileWithIcon,
    mockContentTileWithImage,
} from './content-tile.mock';
import { mockEventSeriesBase } from './event-series.mock';
import { newsPageMock } from './page-types';

export const mockAssemblyReferenceCollectionBase: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    sys: {
        id: '5ZUhvnVqM4DLneocJcONhg',
        contentType: {
            sys: {
                id: 'assemblyReferenceCollection',
            },
        },
    },
    fields: {
        collectionType: 'Content tiles',
        style: 'Large',
        layout: 'Default',
        invertFontColour: false,
    },
};

export const mockAssemblyReferenceCollectionTilesImageLarge: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionBase,
    fields: {
        ...mockAssemblyReferenceCollectionBase.fields,
        contentTiles: [
            mockContentTileWithImage,
            mockContentTileWithImage,
            mockContentTileWithImage,
            mockContentTileWithImage,
            mockContentTileWithImage,
            mockContentTileWithImage,
            mockContentTileWithImage,
        ],
    },
};

export const mockAssemblyReferenceCollectionTilesImageSmall: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionTilesImageLarge,
    fields: {
        ...mockAssemblyReferenceCollectionTilesImageLarge.fields,
        style: 'Small',
    },
};

export const mockAssemblyReferenceCollectionTilesIconLarge: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionBase,
    fields: {
        ...mockAssemblyReferenceCollectionBase.fields,
        contentTiles: [
            mockContentTileWithIcon,
            mockContentTileWithIcon,
            mockContentTileWithIcon,
            mockContentTileWithIcon,
            mockContentTileWithIcon,
            mockContentTileWithIcon,
            mockContentTileWithIcon,
        ],
    },
};

export const mockAssemblyReferenceCollectionTilesIconSmall: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionTilesIconLarge,
    fields: {
        ...mockAssemblyReferenceCollectionTilesIconLarge.fields,
        style: 'Small',
    },
};

export const mockAssemblyReferenceCollectionEventSeries: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionBase,
    fields: {
        ...mockAssemblyReferenceCollectionBase.fields,
        collectionType: 'Event series',
        eventSeries: [
            mockEventSeriesBase,
            mockEventSeriesBase,
            mockEventSeriesBase,
        ],
    },
};

export const mockAssemblyReferenceCollectionNews: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionBase,
    fields: {
        ...mockAssemblyReferenceCollectionBase.fields,
        collectionType: 'News',
        news: [newsPageMock, newsPageMock, newsPageMock],
    },
};

export const mockEmptyAssemblyReferenceCollectionNews: Content<
    'assemblyReferenceCollection',
    AssemblyReferenceCollectionFields
> = {
    ...mockAssemblyReferenceCollectionBase,
    fields: {
        ...mockAssemblyReferenceCollectionBase.fields,
        collectionType: 'News',
    },
};
